import { render } from "./TicketTableBody.vue?vue&type=template&id=6b71ae50"
import script from "./TicketTableBody.vue?vue&type=script&lang=js"
export * from "./TicketTableBody.vue?vue&type=script&lang=js"

import "./TicketTableBody.vue?vue&type=style&index=0&id=6b71ae50&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__